module.exports = "/dashboard/components/upcomingShiftsToClockInComponent-7221f8.html";